import { Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { layoutMenu, meetingRoomPages } from '../../menu';
import setRouteState from '../../utils/saveRouteState';
import { useDispatch } from 'react-redux';
import { addUserData } from '../../store/actions';
import { addConfigData } from '../../store/actions3'; 
import { addConfigDataSystem } from '../../store/actions4'; 
import { toast } from "react-toastify";
import { selectAllmenu } from '../../store/actions2';
import {  useEffect, useState } from 'react';
import {  Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
//api
import {
    getConfigsDataList,
    echoPutBack,
    doLogin,
    ssoLogin,
    getPrivilegedTimeMethod
} from "../../api/common_java"; 
import {
    doLoginToken,
} from '../../api/ssoToken';
import{
  getUserEssentialInformation,
  getConfigsDataSystemList
}from '../../api/common_java'
function isSameURL(url1: string, url2: string) {
    // 清除开头和结尾的斜杠
    url1 = url1.replace(/^\/|\/$/g, '');
    url2 = url2.replace(/^\/|\/$/g, '');

    // 判断两个URL是否相同
    return url1 === url2;
}

function checkName(array: any, searchString: string) {
    // 遍历数组中的每个元素
    for (let i = 0; i < array.length; i++) {
        // 如果当前元素是数组，则递归调用checkName函数进行进一步判断
        if (array[i]['child']) {
            if (checkName(array[i]['child'], searchString)) {
                return true; // 返回true，表示找到匹配的name属性
            }
        } else {
            // 检查name属性的值是否包含搜索字符串
            const sameURL = isSameURL(array[i]['name'], searchString);
            if (sameURL) {
                return true; // 找到匹配的name属性，返回true
            }
        }
    }

    return false; // 没有找到匹配的name属性，返回false
}
async function getConfigSystemData(dispatch:any){
    let resultData:any = await getConfigsDataSystemList({
        filters: [
            "group:AND;oid|eq|123456789"
        ]
    });
    if(resultData.code!=200){
        echoPutBack({resultMsg:"无配置信息",resultCode:0})
        return;
    }
    var mapObj:any = {};
    if(resultData.data&&resultData.data.length>0){
        mapObj = resultData.data.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
        }, {});
        const timestampSeconds = Math.floor(Date.now() / 100000);
        mapObj.expirationTime = timestampSeconds;
    }
    dispatch(addConfigDataSystem(mapObj))
}

//获取参数
async function getUrlSearch(url_data:any,dispatch:any){
    // 去掉前面的问号
    const cleanQueryString = url_data.replace(/^\?/, '');
    // 使用 URLSearchParams 解析查询字符串
    const params = new URLSearchParams(cleanQueryString);
    // 将 URLSearchParams 转换为对象
    const queryParamsObj:any = {};
    for (const [key, value] of params.entries()) {
        queryParamsObj[key.toLowerCase()] = value;
    }
    if(queryParamsObj.ssotoken !== undefined&&queryParamsObj.username!==undefined&&queryParamsObj.ssotimes!==undefined){
        //单点登录
        // let result:any = await doLoginToken({"ssoToken": queryParamsObj.ssoToken})
        // if(result.hasOwnProperty("code")&&result.code==401){
        //     toast.warn(
        //         result.data,
        //         {
        //             position: toast.POSITION.TOP_CENTER,
        //             hideProgressBar: true,
        //             theme: "colored",
        //         }
        //     );
        //     return null;
		// }else{
            let response:any = await ssoLogin({
                "userName": queryParamsObj.username,
                "ssoToken":queryParamsObj.ssotoken,
                "ssoTimes":queryParamsObj.ssotimes
            })
            if (response) {
                if(response.hasOwnProperty('token')){
                    localStorage.setItem("ycToken",response.token)
                }else{
                    toast.error(
                    `获取token失败`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        theme: "colored",
                    }
                    );
                    return;
                }
        
                //查询用户信息和菜单权限
                let userData:any = await getUserEssentialInformation()
        
                if (!userData.roles||userData.roles.length<=0) {
                    return toast.warn(
                    `用户${userData.user.username},暂无分配权限！`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        theme: "colored",
                    }
                    );
                }
        
                if (!userData.menus||userData.menus.length <= 0) {
                    return toast.warn(
                    `用户${userData.user.username},暂无菜单权限！`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        theme: "colored",
                    }
                    );
                }
        
                let parentData: any = [],
                    menuData: any = [],
                    target: any = "/";
                
                parentData = userData.menus.reduce((acc: any, i: any) => {
                    acc[i.id] = i;
                    return acc;
                }, {});
        
                // 使用 for-of 循环来遍历数组，减少不必要的计算
                for (const i of userData.menus) {
                    if (i.id === userData.roles.target) target += parentData[i.id].name;
                }
        
                userData.menus.map((j: any) => {
                    if (j.pid === 0) {
                    menuData.push(j);
                    } else {
                    if (parentData[j.pid] !== undefined) {
                        if (parentData[j.pid].child === undefined) {
                        parentData[j.pid].child = [];
                        }
                        parentData[j.pid].child.push(j);
                    }
                    }
                });
        
                let responseData = {
                    ...userData.user,
                    groupname: userData.roles.title,
                    target: target,
                    depart_room: userData.user.dept? userData.user.dept.roomId.split(',') : [],
                    menu: menuData,
                    refer: userData.permissions
                };
        
                const arr: any = {};
        
                for (let i in menuData) {
                     //跳过权限菜单
                    if(menuData[i].id<=10){
                        continue;
                    }
                    arr[menuData[i].oid] = {
                    id: menuData[i].oid,
                    text: menuData[i].title,
                    icon: menuData[i].css,
                    path: menuData[i].name,
                    child: menuData[i].child,
                    subMenu: null,
                    };
        
                }
        
                for (let k in arr) {
        
                    let list = arr[k].child;
        
                    if (list && list.length > 0) {
        
                    arr[k].subMenu = {};
        
                    for (let ke in list) {
        
                        arr[k].subMenu[list[ke].oid] = {
                        id: list[ke].oid,
                        text: list[ke].title,
                        icon: list[ke].css,
                        path: '/' + list[ke].name,
                        subMenu: null,
                        };
        
                        if (list[ke].child?.length > 0) {
        
                        arr[k].subMenu[list[ke].oid].subMenu = {};
        
                        let array = list[ke].child;
        
                        for (let key in array) {
        
                            arr[k].subMenu[list[ke].oid].subMenu[array[key].oid] = {
                            id: array[key].oid,
                            text: array[key].title,
                            icon: array[key].css,
                            path: '/' + array[key].name,
                            subMenu: null,
                            }
        
                        }
        
                        }
        
                    }
        
                    }
        
                }
                dispatch(addUserData(responseData));
                dispatch(selectAllmenu(arr));
                getConfigSystemData(dispatch)

                let result = await getPrivilegedTimeMethod();
                if(result&&result.code==200){
                    echoPutBack({resultMsg:result.msg,resultCode:1})
                }
                return response;
            }
        //}
    }
    return null;
}

export const ProtectedRoute = ({ children }: any) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const urlHost = window.location.host;
    const { pathname, search } = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    //const [userData, setUserData] = useState<any>(null);
    var userData = useSelector((state: any) => state.userData||null);
    const configData = useSelector((state: any) => state.configData|| {});
    const configSystemData = useSelector((state: any) => state.configSystemData|| {});
    const SingleSignOn = configData['SingleSignOn']?Number(configData['SingleSignOn']):0;

    useEffect(() => {
        if (!configData || !configData['expirationTime']) {
            getConfigData();
        }else{
            if(SingleSignOn){
                initializeAuth();
            }else{
                setIsLoading(false);
            }
        }
        if(userData&&(Object.keys(configSystemData).length === 0||!configSystemData['expirationTime'])){
            //获取基本配置
            getConfigSystemData();
        }
    }, []);

    async function getConfigData(){
        let resultData:any = await getConfigsDataList({url:urlHost});
        if(resultData.code!=200){
            echoPutBack({resultMsg:"无配置信息",resultCode:0})
            return;
        }
        var mapObj:any = {};
        if(resultData.data&&resultData.data.length>0){
            mapObj = resultData.data.reduce((acc, item) => {
            acc[item.name] = item.value;
            return acc;
            }, {});
            const timestampSeconds = Math.floor(Date.now() / 100000);
            mapObj.expirationTime = timestampSeconds;
        }
        if (mapObj.hasOwnProperty('SingleSignOn') && Number(mapObj['SingleSignOn']) === 1) {
            await initializeAuth();
        }else{
             setIsLoading(false);
        }
        dispatch(addConfigData(mapObj))
    }
    async function getConfigSystemData(){
        let resultData:any = await getConfigsDataSystemList({
            filters: [
                "group:AND;oid|eq|123456789"
            ]
        });
        if(resultData.code!=200){
            echoPutBack({resultMsg:"无配置信息",resultCode:0})
            return;
        }
        var mapObj:any = {};
        if(resultData.data&&resultData.data.length>0){
            mapObj = resultData.data.reduce((acc, item) => {
            acc[item.name] = item.value;
            return acc;
            }, {});
            const timestampSeconds = Math.floor(Date.now() / 100000);
            mapObj.expirationTime = timestampSeconds;
        }
        dispatch(addConfigDataSystem(mapObj))
    }
    async function initializeAuth() {
        let currentUserData = userData;
        
        if(!currentUserData && search && search.length > 0) {
            try {
                currentUserData = await getUrlSearch(search, dispatch);
                userData = currentUserData;
            } catch (error) {
                console.error("Auth initialization failed:", error);
            }
        } else {
            //setUserData(currentUserData);
            userData = currentUserData;
        }
        setIsLoading(false);
    }

    useEffect(() => {
        const user = userData && userData.id;
        let bl = true;
        if (user) {
            bl = checkName(userData.menu, pathname);
        }

        if (pathname.includes('centerControlView')||pathname.includes('_details') || pathname.includes('installationPackageManagement') || pathname.includes('inkscreenTemplateAdd') || pathname.includes('inkscreenTemplateEdit') || pathname.includes('inkscreenTemplateManagement') || pathname.includes('meetingRoomImg') || pathname.includes('meeting/meetingRoomManagement/product') ) {
            bl = true;
        }
        if (pathname.includes('/paperlessskip') || 
            pathname.includes('/login-in') || 
            pathname.includes('/login-out') || 
            pathname.includes('/meeting/_singleview/dashboardview') || 
            pathname.includes('meeting/_singleview/appointmentmeetingview') || 
            pathname.includes('/meeting/_singleview/meetingmanagementview') || 
            pathname.includes('/meeting/_singleview/mymeetingview') || 
            pathname.includes('/meeting/_singleview/meetingsignatureview')) {
            setRouteState(pathname);
        } else if (user && bl) { // 只有当用户存在且有权限时才设置路由状态
            setRouteState(pathname);
        }
    }, [pathname, userData]); // 依赖pathname, user, bl的变化

    // useEffect(() => {
    //     if(SingleSignOn){
    //          async function initializeAuth() {
    //             let currentUserData = userData;
                
    //             if(!currentUserData && search && search.length > 0) {
    //                 try {
    //                     currentUserData = await getUrlSearch(search, dispatch);
    //                     userData = currentUserData;
    //                 } catch (error) {
    //                     console.error("Auth initialization failed:", error);
    //                 }
    //             } else {
    //                 //setUserData(currentUserData);
    //                 userData = currentUserData;
    //             }
    //             setIsLoading(false);
    //         }
    //         initializeAuth();
    //     }else{
    //         setIsLoading(false);
    //     }
    // }, [search, dispatch, SingleSignOn]);

    if (isLoading) {
        return  (
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
            </div>
        ); // 或其他加载指示器
    }

    
    const user = userData && userData.id
    let bl = true;
    if (user) {
        bl = checkName(userData.menu, pathname)
    }
    if (pathname.includes('centerControlView')||pathname.includes('_details') || pathname.includes('installationPackageManagement') || pathname.includes('inkscreenTemplateAdd') || pathname.includes('inkscreenTemplateEdit') || pathname.includes('meetingRoomImg') || pathname.includes('meeting/meetingRoomManagement/product') ) {
        bl = true
    }
    if (pathname.includes('/paperlessskip')
        ||pathname.includes(`/login-in`) 
    || pathname.includes(`/login-out`) 
    || pathname.includes(`/meeting/_singleview/dashboardview`) 
    || pathname.includes(`meeting/_singleview/appointmentmeetingview`) 
    || pathname.includes(`/meeting/_singleview/meetingmanagementview`) 
    || pathname.includes(`/meeting/_singleview/mymeetingview`) 
    || pathname.includes(`/meeting/_singleview/meetingsignatureview`)
    ||pathname.includes(`/paperless/meetingList/_details/votingShowView`)
    ||pathname.includes(`/paperless/meetingList/_details/finalReportView`)) {
        //setRouteState(pathname);
        return children;
    } else if (!user && pathname !== layoutMenu.login.path) {
        return <Navigate to={layoutMenu.login.path} />;
    } else if ((user && pathname === layoutMenu.login.path) || (user && pathname === "/")) {
        const url3 = userData.target !== "/" ? userData.target : meetingRoomPages.dashboard.path
        return <Navigate to={url3} />;
    } else if (!bl) {
        navigate(-1);
    } else {
        //setRouteState(pathname)
        return children;
    }
};